import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

export const teamsPaginatedBasicQuery = gql`
  query teamsPaginatedBasic(
    $businessId: ID!
    $teamName: String
    $limit: Int
    $searchAfter: String
    $state: TeamState
    $featureFlags: [String]
    $hasBranding: Boolean
    $hasManager: Boolean
  ) {
    teamsPaginated(
      businessId: $businessId
      teamName: $teamName
      limit: $limit
      searchAfter: $searchAfter
      state: $state
      featureFlags: $featureFlags
      hasBranding: $hasBranding
      hasManager: $hasManager
    ) {
      teams {
        uuid
        businessId
        featureFlags
        parentId
        teamName
        teamState
        teamCategory
        public_name
        isRootTeam
      }
      searchAfter
      searchData {
        total
      }
    }
  }
`

export const teamsPaginatedBasicKey = getQueryNames(teamsPaginatedBasicQuery)[0]
